var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('survey', {
    attrs: {
      "detailsData": _vm.surveyDetails,
      "loading": _vm.loading,
      "isSuccessLoad": _vm.isSuccessLoad,
      "isPreview": true
    }
  });
};

var staticRenderFns = [];
export { render, staticRenderFns };